<template>
  <div class="changePass">
    <div class="contair">
      <div class="title">
        <p>修改密码</p>
      </div>
      <div class="content">
        <p class="tips">为确认是您本人操作，请完成以下验证</p>
        <div class="inputGroup">
          <div class="phoneNumber">
            <p>已验手机</p>
            <p>{{phoneNumber}}</p>
          </div>
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item prop="verificationCode" class="verificationCode" label="短信验证码">
              <el-input type="text" v-model.trim="ruleForm.verificationCode" autocomplete="off" placeholder="验证码" class="codeBox"></el-input>
              <div class="verification">
                <div class="message" v-if="countdownClickDisabled">
                  {{verificationMsg}}
                </div>
                <div class="message" @click="getVerificationCode" v-else>
                  {{verificationMsg}}
                </div>
              </div>
            </el-form-item>
            <!-- <el-form-item label="原密码" prop="oldPass">
              <el-input v-model.number="ruleForm.oldPass" autocomplete="off" placeholder="原密码"></el-input>
            </el-form-item> -->
            <el-form-item label="密码" prop="pass">
              <el-input type="password" v-model.trim="ruleForm.pass" autocomplete="off" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input type="password" v-model.trim="ruleForm.checkPass" autocomplete="off" placeholder="确认密码"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')" class="saveButton">确定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default ({
    name: 'changePass',
    comments: {},
    data() {
      var checkOldPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入原密码'));
        } else {
          callback();
        }
      };
      var checkVerificationCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入短信验证码'));
        } else {
          callback();
        }
      };
   
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value))) {
          callback(new Error('8-16位字母或数字，且必须同时包含数字和字母'));
        }else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        verificationMsg: '获取验证码',
        countdownTime: this.$store.state.defaultCountdownTime, //倒计时秒
        countdownClickDisabled: false, //验证码发送控制  false:可点击   true:不可点击
        ruleForm: {
          // oldPass: '',
          pass: '',
          checkPass: '',
          verificationCode: '',
          mobile: sessionStorage.getItem('mobile'), //修改前手机号码,
        },
        phoneNumber: '', //显示手机号
        rules: {
          // oldPass: [{
          //   validator: checkOldPass,
          //   trigger: 'blur'
          // }],
          pass: [{
            validator: validatePass,
            trigger: 'blur'
          }],
          checkPass: [{
            validator: validatePass2,
            trigger: 'blur'
          }],
          verificationCode: [{
            validator: checkVerificationCode,
            trigger: 'blur'
          }]
        }
      }
    },
    mounted() {
      if (this.ruleForm.mobile) {
        this.changPhoneNumber(this.ruleForm.mobile)
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {

            let this_ = this;
            let data_ = {
              "userId": this_.$store.state.userId, //默认用户id
              "password": this_.ruleForm.pass ,//新密码
              "nickname": this_.$store.state.user,
              "client": this_.$store.state.defaultClient,
              "clientSys": this_.$store.state.defaultClientSys,
              "systemcode":this_.$store.state.systemcode //系统编号
            };
            let paramdata = {};
            paramdata.url = '/jwt/user/resetPassWord';
            paramdata.data = data_; //json对象
            paramdata.onSuccess = function(res) {
              if (res.data.ok) {
                this_.$message({
                  message: '密码修改成功',
                  type: 'info'
                });
                this_.$router.push("/memberCenterIndex/personalInformation"); //跳转个人信息页面
              } else {
                let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
                this_.$message({
                  message: errmsg,
                  type: 'warning'
                });
              }
            };
            paramdata.onFailed = function(res) {
              console.log(res);
            };
            this_.$axiosUtil.postServer(paramdata);
          } else {
            // this_.$message({
            //   message:errmsg,
            //   type: 'warning'
            // });
            return false;
          }
        });
      },
      changPhoneNumber(number) {
        this.phoneNumber = number.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2")
      },
      //验证表单
      validateInfo(data_, callback) {
        let this_ = this;
        data_.userId = this_.$store.state.userId; //默认用户id
        let paramdata = {};
        paramdata.url = '/jwt/user/validate';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            if (data_.validateMobile) {
              this_.countdownClickDisabled = false; //手机号码验证通过后允许点击发送验证码
            }
            callback();
          } else {
            let errmsg = res.data.appendmes != undefined ? res.data.appendmes : res.data.errmsg;
            callback(new Error(errmsg));
          }
        };
        paramdata.onFailed = function(res) {
          console.log(res);
        };
        this_.$axiosUtil.postServer(paramdata);
      },
      // 获取验证码
      getVerificationCode() {
        //控制不能重复请求
        if (this.countdownClickDisabled) return;
        this.countdownClickDisabled = true;
        let this_ = this;
        var data_ = {
          "systemcode": this.$store.state.systemcode, //系统编号
          "projectno": this.$store.state.projectno, //项目编号
          "mobile": this_.ruleForm.mobile, //手机号码
          "userId": this.$store.state.userId, //当前账号id
          "userName": this.$store.state.user //当前账号昵称
        };
        let paramdata = {};
        paramdata.url = '/jwt/user/sendVerificationCode';
        paramdata.data = data_; //json对象
        paramdata.onSuccess = function(res) {
          if (res.data.ok) {
            //获取验证码
            this_.countdown();
          } else {
            this_.countdownClickDisabled = false; //获取验证码失败，解禁获取按钮
            this_.$message.error('获取验证码失败原因:' + res.data.errmsg);
          }
        };

        paramdata.onFailed = function(res) {
          this_.countdownClickDisabled = false; //获取验证码失败，解禁获取按钮
        };

        this_.$axiosUtil.postServer(paramdata);

      },
      // 获取验证码倒计时
      countdown() {
        // if(this.countdownClickDisabled)return;
        // this.countdownClickDisabled = true;
        this.countdownTime = this.$store.state.defaultCountdownTime;
        this.verificationMsg = this.countdownTime + 's后重新获取'

        let clock = window.setInterval(() => {

          this.countdownTime--;

          this.verificationMsg = this.countdownTime + 's后重新获取';

          if (this.countdownTime < 0) {

            window.clearInterval(clock);

            this.verificationMsg = '重新获取验证码';

            this.countdownClickDisabled = false;

          }

        }, 1000);
      }
    }
  })
</script>

<style lang="scss" scoped>
  p {
    margin: 0px;
    padding: 0px;
  }

  >>>.el-input__inner {
    width: 325px;
    border-radius: $border-radius;
    height: 35px;
    line-height: 35px;
  }

  >>>.el-input {
    width: 540px;
  }

  .changePass {
    width: 100%;
    height: 100vh;
    background: rgb(244, 245, 246);
  }

  >>>.contair {
    width: 1280px;
    height: 100%;
    margin: 0px auto;
    background: rgb(244, 245, 246);
  }

  .title {
    height: 40px;
    padding: 8px 0px;
  }

  .title>p {
    font-size: 18px;
    line-height: 40px;
    color: #222;
  }

  >>>.el-form-item__label {
    line-height: 35px;
  }

  >>>.content {
    background: #ffffff;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .phoneNumber {
    display: flex;
    height: 40px;
    margin-bottom: 12px;
  }

  >>>.verificationCode>.el-form-item__content {
    display: flex;
    width: 600px;
  }

  >>>.el-form-item__content {
    line-height: 35px;
  }

  .codeBox {
    width: 200px;
    margin-right: 10px;
  }

  >>>.codeBox>.el-input__inner {
    width: 200px
  }

  .verification {
    width: 115px;
    height: 35px;
    text-align: center;
    background: $color-primary;
    border: 1px solid $color-primary;
    line-height: 35px;
    box-sizing: border-box;
  }

  .verification:hover {
    cursor: pointer;
    background: $color-primary-light-1;
  }

  .verification>p {
    margin: 0px;
    line-height: 40px;
    font-size: 16px;
  }

  .inputGroup {
    width: 800px;
    margin-left: 300px;
  }

  .tips {
    width: 800px;
    margin-left: 360px;
    color: #606266;
    margin-bottom: 12px;
  }

  .phoneNumber>p:first-of-type {
    line-height: 40px;
    width: 100px;
    padding: 0px 12px 0px 0px;
    text-align: right;
    box-sizing: border-box;
    color: #606266;
    font-size: 14px;
  }

  .phoneNumber>p:last-of-type {
    line-height: 40px;
    box-sizing: border-box;
    color: #606266;
    font-size: 14px;
  }

  .saveButton {
    background: $color-primary;
    border-radius: 0px;
    border: 1px solid $color-primary;
    font-size: 16px;
  }

  .saveButton:hover {
    background: $color-primary-light-1;
  }

  .message {
    text-decoration: none;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/changePass.vue